(function() {

var _ = ui._;
ui.productBuild = productBuild;

function node(tag, cls) {
  var $el = _(tag);
  if(cls)
    $el.attr('class', cls);
  return $el;
}

function icon(cls, name) {
  return _('svg').attr('class', cls, 'aria-hidden', 'true').append(_('use').attr('href', '#' + name));
}

function productBuild(product) {
  var lang = ui.lang;
  var product_id = product.product_id;
  var discount_percent = product.price_old ? Math.floor(100 * (product.saleprice - product.price_old) / product.price_old) : 0;

  var $block1 = node('div', 'product-labels-block1 flex flex-col gap-1');
  if(discount_percent)
    $block1.append(node('span', 'bg-accent text-white text-[9px] font-bold px-1.5 py-0.5 rounded leading-none').text(discount_percent + '%'));
  if(product.action_days > 0) {
    var days = product.action_days;
    var days_key = ((days == 1) || ((days > 20) && (days % 10 == 1))) ? 'text_day' : ((days < 5) || ((days > 20) && [2, 3, 4].indexOf(days % 10) !== -1)) ? 'text_day2' : 'text_day5';
    $block1.append(
      node('span', 'inline-flex items-center gap-1 bg-brand text-brand-text text-[9px] font-bold px-1.5 py-0.5 rounded leading-none')
        .append(icon('h-3 w-3', 'svg-icon-clock-l'))
        .text(days + ' ' + (lang[days_key] || ''), true)
    );
  }
  if(product.has_video)
    $block1.append(
      node('div', 'h-6 w-6 rounded-full bg-red-600 flex items-center justify-center text-white group-hover:bg-black transition-colors')
        .append(icon('lucide lucide-play h-3 w-3 fill-current ml-0.5', 'svg-icon-play'))
    );

  var wish_class = ((ui.wish || []).indexOf(product_id) !== -1) ? ' product-wish-icon-filled' : '';
  var $wish = icon('wish-' + product_id + ' z-10 w-5 h-5 text-gray-300 hover:text-accent transition cursor-pointer' + wish_class, 'svg-icon-heart-line')
    .attr('onclick', 'ui.wishToggle(event, ' + product_id + ')');
  var $warranty_wrap = node('div', 'flex items-center gap-2');
  if(product.warranty)
    $warranty_wrap.append(
      node('span', 'product-label-warranty-box').append(
        _('svg').attr('class', 'product-label-warranty-img').append(_('use').attr('href', '#svg-icon-warranty')),
        node('span', 'product-label-warranty').append(
          node('div', 'product-label-warranty-1').text(product.warranty),
          node('div', 'product-label-warranty-2').text(lang['text_year' + product.warranty] || ''),
          node('div', 'product-label-warranty-3').text(lang.text_warranty || '')
        )
      )
    );
  var $block2 = node('div', 'product-labels-block2 flex gap-1').append($wish, $warranty_wrap);

  var $img_wrap = node('div', 'card-img h-32 sm:h-40 flex items-center justify-center mb-3 mt-6').append(
    node('div', 'product-labels').append($block1, $block2)
  );
  if(product.instock && (product.quantity_few || (product.label_new == 4)))
    $img_wrap.append(
      node('div', 'product-labels-bottom2').append(
        product.label_new == 4
          ? node('div', 'product-label-sale').text(product.label_new_text || '')
          : node('div', 'product-label-quantity-few').text(lang.text_label_quantity_few || '')
      )
    );
  $img_wrap.append(
    node('img', 'max-h-full max-w-full object-contain group-hover:scale-105 transition duration-300')
      .attr('src', product.image, 'loading', 'lazy', 'alt', product.title)
  );

  var $manufacturer = node('div', 'h-4 mb-2 flex justify-start');
  if(product.manufacturer_image)
    $manufacturer.append(
      node('img', 'card-brand h-full object-contain object-left').attr('src', product.manufacturer_image, 'loading', 'lazy', 'alt', product.manufacturer)
    );
  else
    $manufacturer.append(node('span', 'text-[10px] text-gray-400 font-medium').text(product.manufacturer || ''));

  var $title = node('div', 'mb-2');
  if(product.type && (product.type !== '&nbsp;'))
    $title.append(node('div', 'text-[10px] text-gray-400 font-bold uppercase mb-0.5').text(product.type));
  $title.append(node('h3', 'text-xs lg:text-sm font-bold text-dark leading-snug line-clamp-2 h-9 group-hover:text-brand transition mb-1').text(product.model || ''));
  if(product.color && (product.color !== '&nbsp;'))
    $title.append(node('div', 'text-[10px] text-gray-500').text(product.color));

  var $stars = node('div', 'flex text-gray-200');
  for(var i = 1; i <= 5; i++)
    $stars.append(icon('w-3 h-3' + (product.rating >= i ? ' text-yellow-400' : ''), 'svg-icon-star' + (product.rating >= i ? '-fill' : '')));
  var $rating = node('div', 'flex items-center gap-1 mb-3').append(
    $stars,
    node('span', 'text-[10px] text-gray-400 flex items-center gap-0.5 ml-1')
      .append(icon('w-3 h-3', 'svg-icon-message-circle'))
      .text(product.reviews, true)
  );

  var $details = node('div', 'card-details flex flex-col flex-grow');
  if(product.instock)
    $details.append(node('div', 'mb-2').append(node('span', 'text-[10px] font-bold uppercase tracking-wider text-green-600').text(lang.text_instock || '')));
  $details.append($manufacturer, $title, $rating);

  var inst_max_months = 0;
  if(ui.payments && product.saleprice && product.instock) {
    var $payments = node('div', 'flex flex-wrap items-center gap-2 mb-2').attr('onclick', 'ui.paymentClick(event)');
    var payments = Object.values(ui.payments);
    for(var i = 0; i < payments.length; i++)
      if((product.saleprice >= payments[i].min_amount) && payments[i].icon && payments[i].is_credit) {
        if(payments[i].month > inst_max_months)
          inst_max_months = payments[i].month;
        $payments.append(
          _('svg')
            .attr('class', 'installment-icon h-[30px] w-[30px] shrink-0 cursor-pointer transition-all duration-150', 'data', payments[i].code, 'role', 'img', 'aria-label', lang[payments[i].code + '_title'] || '')
            .append(_('use').attr('href', '#' + payments[i].icon))
        );
      }
    if($payments.el.childNodes.length)
      $details.append($payments);
  }

  var $card = node(
    'div',
    'bg-white border border-gray-200 rounded-xl p-3 flex flex-col relative hover:shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1)] transition group h-full' + (product.instock ? '' : ' opacity-60')
  ).attr('id', 'p-' + product_id);

  $card.append(
    node('a', 'flex flex-col flex-grow text-left').attr('href', product.href).append($img_wrap, $details)
  );

  var $price;
  if(product.instock) {
    var $prices = node('div', 'flex flex-col');
    if(product.price_old) {
      $prices.append(
        node('span', 'text-[10px] text-gray-400 line-through').text(ui.priceFormat(product.price_old)),
        node('span', 'text-base lg:text-xl font-black text-accent').text(ui.priceFormat(product.saleprice))
      );
    } else
      $prices.append(node('span', 'text-base lg:text-xl font-black text-black').text(ui.priceFormat(product.saleprice)));
    if(inst_max_months > 0)
      $prices.append(
        node('span', 'text-[11px] font-bold text-gray-400 leading-tight mt-0.5')
          .text((lang.text_from || '') + ' ' + Math.ceil(product.saleprice / inst_max_months) + ' ' + (lang.text_uah_per_month || ''))
      );
    $price = node('div', 'card-price mt-auto border-t border-gray-100 pt-3 flex items-center justify-between').attr('data-cart-btn', product_id).append(
      $prices,
      node('button', 'cart-add-only w-10 h-10 bg-brand rounded-lg flex items-center justify-center text-brand-text hover:bg-brand transition active:scale-95 shadow-sm')
        .attr('onclick', 'ui.cartUI.add(event, ' + product_id + ')')
        .append(icon('w-5 h-5', 'svg-icon-shopping-cart')),
      node('button', 'cart-in-cart-only !hidden w-10 sm:w-auto h-10 sm:px-3 bg-black hover:bg-gray-900 rounded-lg flex items-center justify-center sm:gap-2 transition active:scale-95 shadow-sm')
        .attr('onclick', 'ui.cartUI.update(true)')
        .append(
          icon('w-5 h-5 text-brand', 'svg-icon-shopping-cart'),
          node('span', 'hidden sm:inline text-[10px] font-bold uppercase tracking-wider text-white').text(lang.text_in_cart || '')
        )
    );
  } else
    $price = node('div', 'card-price mt-auto border-t border-gray-100 pt-3').append(
      node('button', 'w-full py-2 text-xs font-bold text-gray-500 hover:text-black transition')
        .attr('onclick', 'ui.notifyMe(event, ' + product_id + ')')
        .text(lang.text_notify_me || '')
    );
  $card.append($price);

  if(product.related_ids) {
    var $related = node('div', 'product-card-related hidden lg:flex');
    for(var i = 0; i < product.related_ids.length; i++) {
      var p = ui.productGet(product.related_ids[i]);
      if(p)
        $related.append(
          node('a', p.instock ? '' : 'product-related-not-instock').attr('href', p.href, 'title', p.title).append(
            node('img', 'product-card-related-img').attr('src', p.image, 'loading', 'lazy', 'alt', p.title)
          )
        );
    }
    $card.append($related);
  }

  return $card;
}

})();